'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$ConfigureGroupRules(code, selected) {
  this.Yw = null;
  this.Yx = null;
  this.Yw = code;
  this.Yx = selected;
}
export { $c_Lpresto_types$proto$ConfigureGroupRules as $c_Lpresto_types$proto$ConfigureGroupRules };
$p = $c_Lpresto_types$proto$ConfigureGroupRules.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$ConfigureGroupRules;
/** @constructor */
function $h_Lpresto_types$proto$ConfigureGroupRules() {
}
export { $h_Lpresto_types$proto$ConfigureGroupRules as $h_Lpresto_types$proto$ConfigureGroupRules };
$h_Lpresto_types$proto$ConfigureGroupRules.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$proto$ConfigureGroupRules)) {
    if ((this.Yw === x$0.Yw)) {
      var x = this.Yx;
      var x$2 = x$0.Yx;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "ConfigureGroupRules";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Yw;
  }
  if ((n === 1)) {
    return this.Yx;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$proto$ConfigureGroupRules(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kC)));
}
export { $isArrayOf_Lpresto_types$proto$ConfigureGroupRules as $isArrayOf_Lpresto_types$proto$ConfigureGroupRules };
var $d_Lpresto_types$proto$ConfigureGroupRules = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$ConfigureGroupRules, "presto.types$proto$ConfigureGroupRules", ({
  kC: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$ConfigureGroupRules as $d_Lpresto_types$proto$ConfigureGroupRules };
//# sourceMappingURL=presto.types$proto$-Configure-Group-Rules.js.map
